import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ScrollService {
  private scrolledSubject = new BehaviorSubject<boolean>(false);
  scrolled$ = this.scrolledSubject.asObservable();

  setScrolled(value: boolean) {
    this.scrolledSubject.next(value);
  }
}